import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CloneBusinessOption, KeyValueId, KeyValueSet, LocalService, Status } from 'src/service/local.service';
import { SellerManagementService } from 'src/service/seller-management.service';

@Component({
  selector: 'app-clone-business',
  templateUrl: './clone-business.component.html',
  styleUrl: './clone-business.component.scss'
})
export class CloneBusinessComponent {

  businessCode: number;
  businessPin: number;
  //pin: number = 0;
  fromBusinessName: string;
  fromBusinessId: string;

  newBusinessName: string;
  newBusinessAddress: string;

  cloneOptions: KeyValueSet[] = [
    { isSelected: true, key: CloneBusinessOption.Products.toString(), value: 'Products + Quick Pick Labels' } as KeyValueSet,
    { isSelected: true, key: CloneBusinessOption.QrGeneratorConfig.toString(), value: 'Qr Generator Config' } as KeyValueSet,
    { isSelected: true, key: CloneBusinessOption.CustomLabelsConfig.toString(), value: 'Custom Labels Config' } as KeyValueSet,
    { isSelected: true, key: CloneBusinessOption.LocalPrintersConfig.toString(), value: 'Local Printers Config' } as KeyValueSet,
    { isSelected: true, key: CloneBusinessOption.DecviceSettingsConfig.toString(), value: 'Decvice Settings Config' } as KeyValueSet
  ];

  constructor(public localService: LocalService, private sellerManagementService: SellerManagementService, private router: Router) { }

  onAuthenticate(): void {
    if (this.businessCode && this.businessPin) {
      this.sellerManagementService.getBusinessByBusinessIdentificationCode(this.businessCode.toString(), this.businessPin.toString()).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        if (result.status == Status.Success) {
          this.fromBusinessName = result.value;
          this.fromBusinessId = result.id;
        }
      });
    }
  }

  onClone() {
    if (this.fromBusinessId && this.fromBusinessId.length > 5 && this.newBusinessName && this.newBusinessName.trim().length > 0 && this.newBusinessAddress && this.newBusinessAddress.trim().length > 0) {
      const cloneOptions = this.cloneOptions.filter(x => x.isSelected).map(x => Number(x.key));

      this.sellerManagementService.cloneBusiness(this.fromBusinessId, this.newBusinessName, this.newBusinessAddress, cloneOptions).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        if (result.status == Status.Success) {
          this.router.navigate(['/seller' + this.localService.basicParamsString, result.id]);
        }
      });
    }
  }
}
